/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	jQuery("#ae-cform-reg-item-email-1 input").attr("placeholder", "EMAIL ADDRESS (REQUIRED)");

    jQuery(".cookie").on("click", function (event) {
		jQuery("#_evh-link").trigger("click");
	  });

	var $win = jQuery(window),
	$body = jQuery('body'),
	$main = jQuery('.main');

	jQuery('.banner-slider').slick({
		dots: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	}); 

	jQuery('.release-list').slick({
		slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
		centerMode: false,
        cssEase: "ease-in-out",
        useTransform: true,
        dots: false,
        fade: false,
		responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
  					]
	});
	
	jQuery('.video-list').slick({
        speed: 300,
		centerMode: false,
        cssEase: "ease-in-out",
        useTransform: true,
        dots: false,
        fade: false,
		rows: 2,
		slidesToShow: 2,
		slidesToScroll: 2,
		responsive: [
						{
							breakpoint: 1200,
							settings: {
								rows: 2,
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
						{
							breakpoint: 1024,
							settings: {
        						rows: 2,
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						}
  					]
	});

	jQuery('.store-list').slick({
		dots: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	}); 

	if( $body.hasClass('home') ) {
		jQuery(".subscribe a").click(function (){
			var $container = jQuery("html,body");
			var $scrollTo = jQuery('.section-subscribe');

			$container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0},1000);
		});
		setTimeout(
			function() 
			{
			  //do something special
		  jQuery('#modalform').foundation('open');
		}, 10000);
	}else{
		jQuery('.subscribe a').attr("data-open", "modalform");
	}

	jQuery('.top-bar .menu-bars').on('click', function() {
		jQuery(this).find('.fas').toggleClass('fa-times');
	});
	jQuery('.js-off-canvas-overlay').on('click', function() {
		jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
	});
	
	if( $body.hasClass('single-release') || $body.hasClass('page-id-5') || $body.hasClass('page') ) {
		var ppp_release = 6; // Post per page
		var pageNumber_release = 1;

		function load_posts(){
			pageNumber_release++;
			var str_release = '&pageNumber=' + pageNumber_release + '&ppp=' + ppp_release + '&action=more_release_ajax';
			jQuery.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_posts.ajaxurl,
				data: str_release,
				success: function(data){
					//console.log('funciona');
					var $data_release = jQuery(data);
					if($data_release.length){
						jQuery("#releases-list").append($data_release);
						jQuery("#more_releases").attr("disabled",false);
					} else{
						jQuery("#more_releases").attr("disabled",true);
						jQuery("#more_releases").addClass("disabled");
					}
				},
				error : function(jqXHR, textStatus, errorThrown) {
					//console.log('error');
					jQuery('.latest .section-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		jQuery("#more_releases").on("click",function(e){ // When btn is pressed.
			e.preventDefault();

			jQuery("#more_releases").attr("disabled",true); // Disable the button, temp.
			load_posts();
		});
	} // single-release and music page

	if( $body.hasClass('single-video') || $body.hasClass('page-id-8') || $body.hasClass('page') ) {
		var ppp = 4; // Post per page
		var pageNumber = 1;

		function load_posts(){
			pageNumber++;
			var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_videos_ajax';
			jQuery.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_posts.ajaxurl,
				data: str,
				success: function(data){
					//console.log('funciona');
					var $data = jQuery(data);
					if($data.length){
						jQuery("#videos-list").append($data);
						jQuery("#more_videos").attr("disabled",false);
					} else{
						jQuery("#more_videos").attr("disabled",true);
						jQuery("#more_videos").addClass("disabled");
					}
				},
				error : function(jqXHR, textStatus, errorThrown) {
					//console.log('error');
					jQuery('.latest .section-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		jQuery("#more_videos").on("click",function(e){ // When btn is pressed.
			e.preventDefault();

			jQuery("#more_videos").attr("disabled",true); // Disable the button, temp.
			load_posts();
		});
	} // single-video and video page
	
	const $line = jQuery('#tabLine');
	const $tabsContainer = jQuery('#collapsing-tabs');
	const $tabs = jQuery('.tabs-title');

	function moveLineTo($element) {
		if (!$element.length) return;
		
		const pos = $element.position();
		const topPosition = pos.top + $element.outerHeight() - 2;

		$line.css({
		left: pos.left + 'px',
		top: topPosition + 'px',
		width: $element.outerWidth() + 'px',
		opacity: 1
		});
	}

	let $activeTab = $tabs.filter('.is-active, .active');

	jQuery(window).on('load resize', function () {
		$activeTab = $tabs.filter('.is-active, .active');
		moveLineTo($activeTab);
	});

	setTimeout(function () {
		$activeTab = $tabs.filter('.is-active, .active');
		moveLineTo($activeTab);
	}, 100);

	$tabs.on('mouseenter', function () {
		moveLineTo(jQuery(this));
	});

	$tabs.on('click', function () {
		const $this = jQuery(this);
		setTimeout(function () {
		$tabs.removeClass('active is-active');
		$this.addClass('is-active');
		$activeTab = $this;
		moveLineTo($activeTab);
		}, 10);
	});

	$tabsContainer.on('mouseleave', function () {
		if ($activeTab.length) {
		moveLineTo($activeTab);
		} else {
		$line.css('opacity', 0);
		}
	});
});    